import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const getLocalesData = () => {
  const files = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const localeData = {
      datetimeFormats: {},
      numberFormats: {},
      messages: {}
  }
  const keys = files.keys();
  keys.forEach((key) => {
      // extract name without extension
      const matched = key.match(/([A-Za-z0-9-_]+)\./i)
      if (matched && matched.length > 1) {
          const localeId = matched[1]
          // from each file, set the related messages property
          localeData.datetimeFormats[localeId] = files(key).datetimeFormats
          localeData.numberFormats[localeId] = files(key).numberFormats
          localeData.messages[localeId] = files(key).messages
      }
  })
  return localeData
}

const data = getLocalesData()

// Get initial locale from localStorage or use default
const getInitialLocale = () => {
  try {
    const savedLanguage = localStorage.getItem('selectedLanguage')
    if (savedLanguage) {
      const parsedLanguage = savedLanguage
      // Check if the locale exists in our available locales
      if (data.messages[parsedLanguage.code]) {
        return parsedLanguage.code
      }
    }
  } catch (error) {
    console.error('Error reading language from localStorage:', error)
  }
  return 'th-TH' // Default fallback
}

const initialLocale = getInitialLocale()

const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: 'th-TH',
  messages: data.messages,
  datetimeFormats: data.datetimeFormats,
  numberFormats: data.numberFormats
});

export default i18n; 